import { useMemo } from "react";
import { useSelector } from "react-redux";
import { selectors } from "store";

export type NameHook = string;

/**
 * Returns the current lead name to be displayed
 */
export default function useName(isLoading = false): NameHook {
  const lead = useSelector(selectors.lead.getEntity);

  const name = useMemo<NameHook>(() => {
    if (isLoading) return "";
    return [
      lead?.lead_applicant?.customer_details?.first_name,
      lead?.lead_applicant?.customer_details?.last_name,
    ]
      .filter(Boolean)
      .join(" ");
  }, [lead, isLoading]);

  return name;
}
